document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-faq-toggle]").forEach(toggle => {
        toggle.addEventListener("click", () => {
            const parent = toggle.closest("[data-faq]");
            parent.classList.toggle("active");
        });
    });
});
